import { CheckImageModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../../shared';

export class CheckImage extends DomainEntity<CheckImageModelDto> {
    constructor(public source: CheckImageModelDto) {
        super(source);
    }

    public createDefault(): this {
        return new CheckImage({
            frontImage: '',
            backImage: '',
        }) as this;
    }

    public get id() {
        return this.source.checkId ?? '';
    }

    public get frontImage() {
        return this.source.frontImage ?? '';
    }

    public get backImage() {
        return this.source.backImage ?? '';
    }
}
